import _ from 'lodash';

export const last = (values) => values[values.length - 1];

export const sum = (values) => values.reduce((s, v) => s + v, 0);

export const avg = (values) => sum(values) / values.length;

export const max = (values) => Math.max(...values);

export const countUniq = (values) => _.uniq(values || []).length;
